import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "providers/Auth";
import { useConfig } from "providers/Config";
import {
  SELF_SERVE_TENANT_ID,
  ENROLL_PATH,
  ONBOARDING_STEPS,
} from "types/onboarding";
import FullPageLoader from "UIComponents/FullPageLoader";

function UnauthorizedRoute({ children, redirectTo = "/" }) {
  const { appConfig } = useConfig();
  const { auth: authCfg } = appConfig || {};
  const fallback = authCfg?.redirectTo ?? redirectTo;
  const { auth } = useAuth();
  const location = useLocation();

  if (!auth?.isAuthenticated) return children;

  if (!auth?.claims?.tenant) {
    return appConfig?.components?.Loading ? (
      <appConfig.components.Loading />
    ) : (
      <FullPageLoader />
    );
  }

  if (auth.claims.tenant === SELF_SERVE_TENANT_ID) {
    if (location.pathname.startsWith(ENROLL_PATH)) return children;
    return (
      <Navigate to={`${ENROLL_PATH}/${ONBOARDING_STEPS.survey}`} replace />
    );
  }

  if (location.pathname === fallback) return children;
  return <Navigate to={fallback} replace />;
}

export default UnauthorizedRoute;
